import styled from "styled-components";

// Header container styles
export const HeaderContainer = styled.header.attrs({
  className:
    "flex justify-between items-center py-4 px-8 bg-gray-100 shadow-md relative z-10",
})``;

// Logo Text
export const LogoText = styled.span.attrs({
  className:
    "cursor-pointer text-5xl font-bold text-[#003366] hover:text-[#FF6600] transition",
})`
  background-image: linear-gradient(90deg, #003366, #ff6600);
  -webkit-background-clip: text;
  color: transparent;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease-in-out, text-shadow 0.3s ease-in-out;

  &:hover {
    transform: scale(1.1);
    text-shadow: 4px 4px 8px rgba(255, 102, 0, 0.5);
  }
`;

// Desktop Navigation Links
export const NavLinks = styled.nav.attrs({
  className: "hidden lg:flex space-x-6",
})``;

// Individual NavLink
export const NavLink = styled.a.attrs({
  className:
    "text-[#003366] font-semibold hover:text-[#FF6600] transition text-xl",
})``;

// Hamburger Menu (for mobile)
export const HamburgerMenu = styled.div.attrs({
  className: "text-3xl cursor-pointer lg:hidden",
})``;

// Mobile Navigation Links
export const MobileNavLinks = styled.nav.attrs({
  className:
    "absolute top-full left-0 w-full bg-gray-100 shadow-md py-4 flex flex-col items-center space-y-4 lg:hidden",
})``;

// Individual Mobile NavLink
export const MobileNavLink = styled.a.attrs({
  className:
    "text-[#003366] font-semibold hover:text-[#FF6600] transition text-xl",
})``;
